// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml from "rescript/lib/es6/caml.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as PlApi from "../player/PlApi.bs.js";
import * as React from "react";
import * as Colors from "common/src/Colors.bs.js";
import * as Global from "common/src/Global.bs.js";
import * as PlInfo from "./PlInfo.bs.js";
import * as Region from "common/src/Region.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as $$Promise from "common/src/Promise.bs.js";
import * as Tooltip from "common/src/components/Tooltip.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as LpChartUtils from "common/src/LpChartUtils.bs.js";
import * as Belt_MapString from "rescript/lib/es6/belt_MapString.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as SnackbarService from "common/src/SnackbarService.bs.js";
import * as Belt_MutableSetString from "rescript/lib/es6/belt_MutableSetString.js";

function mergeGames(games, playerMatches, queueId) {
  var existingGames = Belt_MutableSetString.make(undefined);
  Belt_Array.forEach(games, (function (hp) {
          return Belt_MutableSetString.add(existingGames, hp.id);
        }));
  var missingGames = [];
  Belt_Array.forEach(playerMatches, (function (hp) {
          if (hp.queueId === queueId && !Belt_MutableSetString.has(existingGames, hp.id)) {
            missingGames.push(hp);
            return ;
          }
          
        }));
  if (missingGames.length !== 0) {
    return Belt_SortArray.stableSortBy(Belt_Array.concat(missingGames, games), (function (hp1, hp2) {
                  return Caml.caml_float_compare(hp2.dateTime, hp1.dateTime);
                }));
  } else {
    return games;
  }
}

function PlInfoWrap$SetSelectPill(Props) {
  var active = Props.active;
  var set = Props.set;
  var setSet = Props.setSet;
  var setInfo = Props.setInfo;
  var setStr = String(set < 30 ? set : set / 10 | 0);
  var part = set % 10 === 5 ? ".5" : "";
  var match = setInfo.ranked;
  var match$1;
  if (match !== undefined) {
    var lp = match[2];
    var league = match[1];
    var exit = 0;
    switch (league) {
      case "CHALLENGER I" :
      case "GRANDMASTER I" :
      case "MASTER I" :
          exit = 1;
          break;
      default:
        match$1 = [
          LpChartUtils.renderDivisionName(league),
          undefined
        ];
    }
    if (exit === 1) {
      match$1 = lp === 0 ? [
          LpChartUtils.renderDivisionName(league),
          undefined
        ] : [
          LpChartUtils.renderDivisionNameShort(league),
          lp
        ];
    }
    
  } else {
    match$1 = [
      "Unranked",
      undefined
    ];
  }
  var lp$1 = match$1[1];
  var match$2 = setInfo.ranked;
  var color;
  if (match$2 !== undefined) {
    var match$3 = Belt_Array.getExn(match$2[1].split(" "), 0);
    switch (match$3) {
      case "BRONZE" :
          color = Colors.bronze;
          break;
      case "CHALLENGER" :
          color = Colors.challenger2;
          break;
      case "DIAMOND" :
          color = Colors.diamond2;
          break;
      case "GOLD" :
          color = Colors.gold;
          break;
      case "GRANDMASTER" :
          color = Colors.grandmaster2;
          break;
      case "IRON" :
          color = Colors.iron;
          break;
      case "MASTER" :
          color = Colors.master2;
          break;
      case "EMERALD" :
      case "PLATINUM" :
          color = Colors.platinum;
          break;
      case "SILVER" :
          color = Colors.silver;
          break;
      default:
        color = Colors.iron;
    }
  } else {
    color = Colors.iron;
  }
  var el = React.createElement("div", {
        className: "bg-bg2 px-[14px] rounded " + (
          setInfo.played ? "cursor-pointer" : "cursor-not-allowed"
        ) + " font-montserrat font-medium flex items-center gap-[6px] " + (
          active ? "py-[9px] border-b border-t border-secondary-11" : "py-[10px]"
        ),
        onClick: (function (param) {
            if (setInfo.played) {
              return Curry._1(setSet, set);
            }
            
          })
      }, React.createElement("div", {
            className: "w-2 h-2 rounded-full",
            style: Global.s({
                  background: "#" + color
                })
          }), "S" + setStr + part + " ", React.createElement("div", undefined, match$1[0]), lp$1 !== undefined ? React.createElement("span", {
              className: "text-xs leading-none"
            }, "(" + String(lp$1) + "LP)") : null);
  if (setInfo.played) {
    return el;
  } else {
    return React.createElement(Tooltip.make, {
                title: "No games played this set",
                children: el
              });
  }
}

var SetSelectPill = {
  make: PlInfoWrap$SetSelectPill
};

function PlInfoWrap(Props) {
  var region = Props.region;
  var pname = Props.pname;
  var tag = Props.tag;
  var player = Props.player;
  var state = Props.state;
  var dispatch = Props.dispatch;
  var adKey = Props.adKey;
  var setExpandedMatchId = Props.setExpandedMatchId;
  var onHoverMatch = Props.onHoverMatch;
  var setSet = Props.setSet;
  var set = TftSet.use(undefined);
  var masterRankHistory = Belt_MapString.get(state.masterRanks, Region.toApiName(region));
  var allOtherGames = React.useMemo((function () {
          return Belt_Array.keep(player.matches, (function (hp) {
                        return hp.queueId > 1160;
                      }));
        }), [player]);
  var allNormalGames = React.useMemo((function () {
          var match = state.allNormalGames;
          if (match !== undefined && player.playerInfo.name === match[1] && Region.fromApiName(player.playerInfo.region) === match[0]) {
            return mergeGames(match[2], player.matches, 1090);
          }
          
        }), [
        state.allNormalGames,
        player
      ]);
  var allRankedGames = React.useMemo((function () {
          var match = state.allRankedGames;
          if (match !== undefined && player.playerInfo.name === match[1] && Region.fromApiName(player.playerInfo.region) === match[0]) {
            return mergeGames(match[2], player.matches, 1100);
          }
          
        }), [
        state.allRankedGames,
        player
      ]);
  var allHrGames = React.useMemo((function () {
          var match = state.allHrGames;
          if (match !== undefined && player.playerInfo.name === match[1] && Region.fromApiName(player.playerInfo.region) === match[0]) {
            return mergeGames(match[2], player.matches, 1130);
          }
          
        }), [
        state.allHrGames,
        player
      ]);
  var allDuoGames = React.useMemo((function () {
          var match = state.allDuoGames;
          if (match !== undefined && player.playerInfo.name === match[1] && Region.fromApiName(player.playerInfo.region) === match[0]) {
            return mergeGames(match[2], player.matches, 1160);
          }
          
        }), [
        state.allDuoGames,
        player
      ]);
  var onUpdatePlayer = React.useCallback((function (param) {
          if (!state.updating) {
            Curry._1(dispatch, /* Refresh */1);
            return $$Promise.consume(PlApi.getPlayer(region, pname, set, tag, undefined), (function (playerResp) {
                          if (playerResp.TAG === /* Ok */0) {
                            Curry._1(dispatch, {
                                  TAG: /* SetPlayerResp */3,
                                  _0: playerResp
                                });
                          } else {
                            var cb = SnackbarService.sub.contents;
                            if (cb !== undefined) {
                              Curry._1(dispatch, /* UpdateFailed */3);
                              Curry._1(cb, "Update failed. Try again in a minute.");
                            } else {
                              Curry._1(dispatch, /* UpdateFailed */3);
                            }
                          }
                          setTimeout((function (param) {
                                  return Curry._1(dispatch, /* ResetRecentlyUpdated */2);
                                }), 30000);
                          
                        }));
          }
          
        }), []);
  var s14Info = Belt_Option.getExn(Caml_option.undefined_to_opt(player.playerInfo.setsRanks.find(function (v) {
                return v.set === 140;
              })));
  var s13Info = Belt_Option.getExn(Caml_option.undefined_to_opt(player.playerInfo.setsRanks.find(function (v) {
                return v.set === 130;
              })));
  var s12Info = Belt_Option.getExn(Caml_option.undefined_to_opt(player.playerInfo.setsRanks.find(function (v) {
                return v.set === 120;
              })));
  var s11Info = Belt_Option.getExn(Caml_option.undefined_to_opt(player.playerInfo.setsRanks.find(function (v) {
                return v.set === 110;
              })));
  var s10Info = Belt_Option.getExn(Caml_option.undefined_to_opt(player.playerInfo.setsRanks.find(function (v) {
                return v.set === 100;
              })));
  var s95Info = Belt_Option.getExn(Caml_option.undefined_to_opt(player.playerInfo.setsRanks.find(function (v) {
                return v.set === 95;
              })));
  Belt_Option.getExn(Caml_option.undefined_to_opt(player.playerInfo.setsRanks.find(function (v) {
                return v.set === 90;
              })));
  var activeSetRanks = player.playerInfo.setsRanks.find(function (v) {
        return v.set === (
                set === 10 ? 100 : set
              );
      });
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "grid grid-cols-1 sm:grid-cols-3 md:grid-cols-6 bg-bg p-2 gap-3 mb-4 self-center"
                }, React.createElement(PlInfoWrap$SetSelectPill, {
                      active: 140 === set,
                      set: 140,
                      setSet: setSet,
                      setInfo: s14Info
                    }), React.createElement(PlInfoWrap$SetSelectPill, {
                      active: 130 === set,
                      set: 130,
                      setSet: setSet,
                      setInfo: s13Info
                    }), React.createElement(PlInfoWrap$SetSelectPill, {
                      active: 120 === set,
                      set: 120,
                      setSet: setSet,
                      setInfo: s12Info
                    }), React.createElement(PlInfoWrap$SetSelectPill, {
                      active: 110 === set,
                      set: 110,
                      setSet: setSet,
                      setInfo: s11Info
                    }), React.createElement(PlInfoWrap$SetSelectPill, {
                      active: 10 === set,
                      set: 10,
                      setSet: setSet,
                      setInfo: s10Info
                    }), React.createElement(PlInfoWrap$SetSelectPill, {
                      active: 95 === set,
                      set: 95,
                      setSet: setSet,
                      setInfo: s95Info
                    })), React.createElement(PlInfo.make, {
                  adKey: adKey,
                  region: region,
                  player: player,
                  allNormalGames: allNormalGames,
                  allRankedGames: allRankedGames,
                  allHrGames: allHrGames,
                  allDuoGames: allDuoGames,
                  allOtherGames: allOtherGames,
                  setExpandedMatchId: setExpandedMatchId,
                  onHoverMatch: onHoverMatch,
                  masterRanks: masterRankHistory,
                  updating: state.updating,
                  recentlyUpdated: state.recentlyUpdated,
                  onUpdatePlayer: onUpdatePlayer,
                  ranks: activeSetRanks === undefined ? undefined : Caml_option.some(activeSetRanks)
                }));
}

var make = React.memo(PlInfoWrap);

export {
  mergeGames ,
  SetSelectPill ,
  make ,
  
}
/* make Not a pure module */
